import text from './SearchDateTimeText.vue'
const SearchDateTimeText = {
  install: function (Vue) {
    Vue.component('SearchDateTimeText', text)
  }
}
export default SearchDateTimeText
